export function parseApiError(error) {
    if (!error.response) {
        return "Неизвестная ошибка";
    }

    const { status, data } = error.response;

    if (status === 401) {
        console.log("data?.detail ", data?.detail)

        let errorMessage = data?.detail
                    
        return errorMessage;

    }

    // 422 – validation / business errors
    if (status === 422 && Array.isArray(data?.detail)) {

        let errorMessage = ""
        
        error?.response?.data?.detail?.forEach(detail => {
            errorMessage = errorMessage + (detail.message || detail.msg) + "\n"
        })
            
        return errorMessage;

    }

    console.log("data?.detail ", data?.detail)

    return (
        data?.detail?.message ??
        data?.detail?.msg ??
        data?.detail ??
        'Something went wrong'
    );
}
